// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3TOGu","head":"ProcedureTableInfo_head__F1oz_"};